var _classCallCheck = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/night_stalker/WebstormProjects/dropMaster2/node_modules/@babel/runtime/helpers/inherits");

// Generated by CoffeeScript 2.4.1
(function () {
  var NodeType, XMLDummy, XMLNode;
  XMLNode = require('./XMLNode');
  NodeType = require('./NodeType'); // Represents a  raw node

  module.exports = XMLDummy =
  /*#__PURE__*/
  function (_XMLNode) {
    "use strict";

    _inherits(XMLDummy, _XMLNode);

    // Initializes a new instance of `XMLDummy`
    // `XMLDummy` is a special node representing a node with 
    // a null value. Dummy nodes are created while recursively
    // building the XML tree. Simply skipping null values doesn't
    // work because that would break the recursive chain.
    function XMLDummy(parent) {
      var _this;

      _classCallCheck(this, XMLDummy);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(XMLDummy).call(this, parent));
      _this.type = NodeType.Dummy;
      return _this;
    } // Creates and returns a deep clone of `this`


    _createClass(XMLDummy, [{
      key: "clone",
      value: function clone() {
        return Object.create(this);
      } // Converts the XML fragment to string
      // `options.pretty` pretty prints the result
      // `options.indent` indentation for pretty print
      // `options.offset` how many indentations to add to every line for pretty print
      // `options.newline` newline sequence for pretty print

    }, {
      key: "toString",
      value: function toString(options) {
        return '';
      }
    }]);

    return XMLDummy;
  }(XMLNode);
}).call(this);